//v1 without pagination

// import { useEffect, useState } from "react";
// import config from '../../config';
// import './DueCus.css'; // Ensure this CSS file contains styling for the Status column if needed.
// import PayModal from './PayModal';

// const AllDueHistory = () => {
//   const expandedColumns = ['Invoice Number', 'Customer Name','Customer Office' , 'Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Status', ];

//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);

//   useEffect(() => {
//     fetchDueCustomer();
//   }, []);

//   const fetchCustomerName = async (cusId) => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
//       if (response.ok) {
//         const customer = await response.json();
//         return customer.cusName;
//       }
//       return 'Unknown Customer';
//     } catch {
//       return 'Unknown Customer';
//     }
//   };

//   const fetchDueCustomer = async () => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/invoices`);
//       if (!response.ok) {
//         setError('Failed to fetch Sales Invoices');
//         return;
//       }
//       const invoices = await response.json();

//       const transactionPromises = invoices.map(async (invoice) => {
//         const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
//         if (transactionResponse.ok) {
//           return await transactionResponse.json();
//         }
//         return [];
//       });

//       const transactionsData = await Promise.all(transactionPromises);

//       const customerNameCache = {}; // Cache to avoid redundant API calls for the same cusId

//       const formattedData = await Promise.all(
//         invoices.map(async (invoice, index) => {
//           const invoiceTransactions = transactionsData[index] || [];
//           const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
//           if (creditTransactions.length === 0) return null;
      
//           const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
//           const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
//           const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);
      
//           // ✅ Ensure `invoice.customer` exists before accessing `cusId`
//           let customerName = "Unknown";
//           let cusOffice = "-";
//           let cusId = "-";
          
//           if (invoice.customer) {
//             cusId = invoice.customer.cusId || "-"; // Safe access with fallback
//             // cusOffice = invoice.customer.cusOffice || "-";
            
//             // if (customerNameCache[cusId]) {
//             //   customerName = customerNameCache[cusId];
//             // } else {
//             //   customerName = await fetchCustomerName(cusId);
//             //   customerNameCache[cusId] = customerName; 
//             // }
//           }
      
//           return {
//             invoiceId: invoice.invoiceId,
//             invoiceNo: invoice.invoiceNo,
//             customerName:invoice.customer?.cusName, // Dynamically fetched customer name
//             cusOffice:invoice.customer?.cusOffice,
//             cusId,
//             store: invoice.store,
//             date: invoice.invoiceDate,
//             totalAmount: transactionPrice,
//             paidAmount: transactionPaid,
//             dueAmount: transactionDue,
//           };
//         })
//       );
      

//       setData(formattedData.filter(Boolean));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePayClick = (invoice) => {
//     setSelectedInvoice({
//       ...invoice,
//       cusId: invoice.cusId || "-" // Use the already extracted `cusId`
//     });
//     setShowModal(true);
//   };
  

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedInvoice(null);
//   };

//   return (
//     <div>
//       <div className="scrolling-container">
//         <div className="new-sales-container">
//           <h4>View All Paid and Unpaid Due History</h4>

//           {isLoading ? (
//             <p>Loading...</p>
//           ) : error ? (
//             <p>Error: {error}</p>
//           ) : null}

//           <table className="due-cus-table">
//             <thead>
//               <tr>
//                 {expandedColumns.map((column, index) => (
//                   <th key={index}>{column}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((item, index) => (
//                 <tr key={index}>
//                   <td>{item.invoiceNo}</td>
//                   <td>{item.customerName}</td>
//                   <td>{item.cusOffice}</td>
//                   <td>{new Date(item.date).toLocaleString()}</td>
//                   <td>{item.totalAmount}</td>
//                   <td>{item.paidAmount}</td>
//                   <td>{item.dueAmount}</td>
//                   <td>
//                     <span
//                       style={{
//                         color: item.dueAmount === 0 ? 'green' : 'orange',
//                         fontWeight: 'bold',
//                       }}
//                     >
//                       {item.dueAmount === 0 ? 'Payments Clear' : 'Pending'}
//                     </span>
//                   </td>
//                   {/* <td>
//                     <button
//                       className="btn btn-success"
//                       onClick={() => handlePayClick(item)}
//                     >
//                       Payment
//                     </button>
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {showModal && selectedInvoice && (
//             <PayModal
//               show={showModal}
//               handleClose={handleCloseModal}
//               invoiceData={selectedInvoice}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AllDueHistory;













//v2 with pagination first page active

// import { useEffect, useState } from "react";
// import config from '../../config';
// import './DueCus.css'; // Ensure this CSS file contains styling for the Status column if needed.
// import PayModal from './PayModal';

// const AllDueHistory = () => {
//   const expandedColumns = ['Invoice Number', 'Customer Name', 'Customer Office', 'Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Status'];

//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
  
//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [paginatedData, setPaginatedData] = useState([]);

//   useEffect(() => {
//     fetchDueCustomer();
//   }, []);

//   // Update paginated data whenever the main data changes or the current page changes
//   useEffect(() => {
//     // Sort data by invoice number in descending order (newest invoices first)
//     const sortedData = [...data].sort((a, b) => {
//       // Extract numeric part if invoice numbers are in a format like "INV-001"
//       const numA = parseInt(a.invoiceNo.replace(/\D/g, ''));
//       const numB = parseInt(b.invoiceNo.replace(/\D/g, ''));
//       return numB - numA; // Descending order
//     });

//     // Calculate total pages
//     const pages = Math.ceil(sortedData.length / itemsPerPage);
//     setTotalPages(pages);

//     // Reverse pagination logic: newest invoices on last page, oldest on first
//     // For this, we re-sort to ascending for display purposes
//     const displayData = [...sortedData].reverse();
    
//     // Get current items
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = displayData.slice(indexOfFirstItem, indexOfLastItem);
    
//     setPaginatedData(currentItems);
//   }, [data, currentPage, itemsPerPage]);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo(0, 0);
//   };

//   const fetchCustomerName = async (cusId) => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
//       if (response.ok) {
//         const customer = await response.json();
//         return customer.cusName;
//       }
//       return 'Unknown Customer';
//     } catch {
//       return 'Unknown Customer';
//     }
//   };

//   const fetchDueCustomer = async () => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/invoices`);
//       if (!response.ok) {
//         setError('Failed to fetch Sales Invoices');
//         return;
//       }
//       const invoices = await response.json();

//       const transactionPromises = invoices.map(async (invoice) => {
//         const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
//         if (transactionResponse.ok) {
//           return await transactionResponse.json();
//         }
//         return [];
//       });

//       const transactionsData = await Promise.all(transactionPromises);

//       const customerNameCache = {}; // Cache to avoid redundant API calls for the same cusId

//       const formattedData = await Promise.all(
//         invoices.map(async (invoice, index) => {
//           const invoiceTransactions = transactionsData[index] || [];
//           const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
//           if (creditTransactions.length === 0) return null;
      
//           const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
//           const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
//           const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);
      
//           // ✅ Ensure `invoice.customer` exists before accessing `cusId`
//           let customerName = "Unknown";
//           let cusOffice = "-";
//           let cusId = "-";
          
//           if (invoice.customer) {
//             cusId = invoice.customer.cusId || "-"; // Safe access with fallback
//             // cusOffice = invoice.customer.cusOffice || "-";
            
//             // if (customerNameCache[cusId]) {
//             //   customerName = customerNameCache[cusId];
//             // } else {
//             //   customerName = await fetchCustomerName(cusId);
//             //   customerNameCache[cusId] = customerName; 
//             // }
//           }
      
//           return {
//             invoiceId: invoice.invoiceId,
//             invoiceNo: invoice.invoiceNo,
//             customerName: invoice.customer?.cusName, // Dynamically fetched customer name
//             cusOffice: invoice.customer?.cusOffice,
//             cusId,
//             store: invoice.store,
//             date: invoice.invoiceDate,
//             totalAmount: transactionPrice,
//             paidAmount: transactionPaid,
//             dueAmount: transactionDue,
//           };
//         })
//       );
      
//       setData(formattedData.filter(Boolean));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handlePayClick = (invoice) => {
//     setSelectedInvoice({
//       ...invoice,
//       cusId: invoice.cusId || "-" // Use the already extracted `cusId`
//     });
//     setShowModal(true);
//   };
  
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedInvoice(null);
//   };

//   return (
//     <div>
//       <div className="scrolling-container">
//         <div className="new-sales-container">
//           <h4>View All Paid and Unpaid Due History</h4>

//           {isLoading ? (
//             <p>Loading...</p>
//           ) : error ? (
//             <p>Error: {error}</p>
//           ) : null}

//           <table className="due-cus-table">
//             <thead>
//               <tr>
//                 {expandedColumns.map((column, index) => (
//                   <th key={index}>{column}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.map((item, index) => (
//                 <tr key={index}>
//                   <td>{item.invoiceNo}</td>
//                   <td>{item.customerName}</td>
//                   <td>{item.cusOffice}</td>
//                   <td>{new Date(item.date).toLocaleString()}</td>
//                   <td>{item.totalAmount}</td>
//                   <td>{item.paidAmount}</td>
//                   <td>{item.dueAmount}</td>
//                   <td>
//                     <span
//                       style={{
//                         color: item.dueAmount === 0 ? 'green' : 'orange',
//                         fontWeight: 'bold',
//                       }}
//                     >
//                       {item.dueAmount === 0 ? 'Payments Clear' : 'Pending'}
//                     </span>
//                   </td>
//                   {/* <td>
//                     <button
//                       className="btn btn-success"
//                       onClick={() => handlePayClick(item)}
//                     >
//                       Payment
//                     </button>
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {totalPages > 1 && (
//             <div className="pagination justify-content-center mt-3">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage <= 1}
//               >
//                 Previous
//               </button>
//               {/* First page */}
//               {totalPages > 1 && (
//                 <span
//                   className={`mx-1 px-2 py-1 border ${currentPage === 1 ? 'border-primary fw-bold' : 'border-transparent'}`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handlePageChange(1)}
//                 >
//                   1
//                 </span>
//               )}
//               {currentPage > 3 && <span className="mx-1">...</span>}
//               {/* Page Numbers */}
//               {Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
//                 .filter(page => page > 1 && page < totalPages)
//                 .map(page => (
//                   <span
//                     key={page}
//                     className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handlePageChange(page)}
//                   >
//                     {page}
//                   </span>
//                 ))
//               }
//               {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
//               {/* Last page */}
//               {totalPages > 1 && (
//                 <span
//                   className={`mx-1 px-2 py-1 border ${currentPage === totalPages ? 'border-dark fw-bold' : 'border-transparent'}`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handlePageChange(totalPages)}
//                 >
//                   {totalPages}
//                 </span>
//               )}
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage >= totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           )}

//           {showModal && selectedInvoice && (
//             <PayModal
//               show={showModal}
//               handleClose={handleCloseModal}
//               invoiceData={selectedInvoice}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AllDueHistory;









//v4 pagination last page active
import { useEffect, useState } from "react";
import config from '../../config';
import './DueCus.css'; // Ensure this CSS file contains styling for the Status column if needed.
import PayModal from './PayModal';
import toast from "react-hot-toast";

const AllDueHistory = () => {
  const expandedColumns = ['Invoice Number', 'Customer Name', 'Customer Office', 'Sold Date', 'Total Amount', 'Paid Amount', 'Due Amount', 'Status'];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  
  // Pagination states - initialize currentPage to null instead of 1
  const [currentPage, setCurrentPage] = useState(null); // Start with null to set it after we know totalPages
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);

  useEffect(() => {
    fetchDueCustomer();
  }, []);

  // Update total pages whenever data changes
  useEffect(() => {
    const pages = Math.ceil(data.length / itemsPerPage);
    setTotalPages(pages);
    
    // Set currentPage to the last page when data first loads
    if (currentPage === null && pages > 0) {
      setCurrentPage(pages);
    }
  }, [data, itemsPerPage]);

  // Update paginated data whenever the currentPage changes or is set
  useEffect(() => {
    // Only process if currentPage is set and not null
    if (currentPage !== null) {
      // Sort data by invoice number in descending order (newest invoices first)
      const sortedData = [...data].sort((a, b) => {
        // Extract numeric part if invoice numbers are in a format like "INV-001"
        const numA = parseInt(a.invoiceNo.replace(/\D/g, ''));
        const numB = parseInt(b.invoiceNo.replace(/\D/g, ''));
        return numB - numA; // Descending order
      });

      // Reverse pagination logic: newest invoices on last page, oldest on first
      // For this, we re-sort to ascending for display purposes
      const displayData = [...sortedData].reverse();
      
      // Get current items
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = displayData.slice(indexOfFirstItem, indexOfLastItem);
      
      setPaginatedData(currentItems);
    }
  }, [data, currentPage, itemsPerPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const fetchCustomerName = async (cusId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
      if (response.ok) {
        const customer = await response.json();
        return customer.cusName;
      }
      return 'Unknown Customer';
    } catch {
      return 'Unknown Customer';
    }
  };

  const fetchDueCustomer = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/invoices`);
      if (!response.ok) {
        setError('Failed to fetch Sales Invoices');
        return;
      }
      const invoices = await response.json();

      const transactionPromises = invoices.map(async (invoice) => {
        const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
        if (transactionResponse.ok) {
          return await transactionResponse.json();
        }
        return [];
      });

      const transactionsData = await Promise.all(transactionPromises);

      const customerNameCache = {}; // Cache to avoid redundant API calls for the same cusId

      const formattedData = await Promise.all(
        invoices.map(async (invoice, index) => {
          const invoiceTransactions = transactionsData[index] || [];
          const creditTransactions = invoiceTransactions.filter(transaction => transaction.transactionType === 'credit');
          if (creditTransactions.length === 0) return null;
      
          const transactionPaid = creditTransactions.reduce((total, transaction) => total + transaction.paid, 0);
          const transactionDue = creditTransactions.reduce((total, transaction) => total + transaction.due, 0);
          const transactionPrice = creditTransactions.reduce((total, transaction) => total + transaction.price, 0);
      
          // ✅ Ensure `invoice.customer` exists before accessing `cusId`
          let customerName = "Unknown";
          let cusOffice = "-";
          let cusId = "-";
          
          if (invoice.customer) {
            cusId = invoice.customer.cusId || "-"; // Safe access with fallback
            // cusOffice = invoice.customer.cusOffice || "-";
            
            // if (customerNameCache[cusId]) {
            //   customerName = customerNameCache[cusId];
            // } else {
            //   customerName = await fetchCustomerName(cusId);
            //   customerNameCache[cusId] = customerName; 
            // }
          }
      
          return {
            invoiceId: invoice.invoiceId,
            invoiceNo: invoice.invoiceNo,
            customerName: invoice.customer?.cusName, // Dynamically fetched customer name
            cusOffice: invoice.customer?.cusOffice,
            cusId,
            store: invoice.store,
            date: invoice.invoiceDate,
            totalAmount: transactionPrice,
            paidAmount: transactionPaid,
            dueAmount: transactionDue,
          };
        })
      );
      
      setData(formattedData.filter(Boolean));
    } catch (err) {
      setError(err.message);
      toast.error("Failed to fetch Due Customer list",err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePayClick = (invoice) => {
    setSelectedInvoice({
      ...invoice,
      cusId: invoice.cusId || "-" // Use the already extracted `cusId`
    });
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedInvoice(null);
  };

  return (
    <div>
      <div className="scrolling-container">
        <div className="new-sales-container">
          <h4>View All Paid and Unpaid Due History</h4>

          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>Error: {error}</p>
          ) : null}

          <table className="due-cus-table">
            <thead>
              <tr>
                {expandedColumns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={index}>
                  <td>{item.invoiceNo}</td>
                  <td>{item.customerName}</td>
                  <td>{item.cusOffice}</td>
                  <td>{new Date(item.date).toLocaleString()}</td>
                  <td>{item.totalAmount}</td>
                  <td>{item.paidAmount}</td>
                  <td>{item.dueAmount}</td>
                  <td>
                    <span
                      style={{
                        color: item.dueAmount === 0 ? 'green' : 'orange',
                        fontWeight: 'bold',
                      }}
                    >
                      {item.dueAmount === 0 ? 'Payments Clear' : 'Pending'}
                    </span>
                  </td>
                  {/* <td>
                    <button
                      className="btn btn-success"
                      onClick={() => handlePayClick(item)}
                    >
                      Payment
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>

          {currentPage && totalPages > 1 && (
            <div className="pagination justify-content-center mt-3">
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage <= 1}
              >
                Previous
              </button>
              {/* First page */}
              {totalPages > 1 && (
                <span
                  className={`mx-1 px-2 py-1 border ${currentPage === 1 ? 'border-primary fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(1)}
                >
                  1
                </span>
              )}
              {currentPage > 3 && <span className="mx-1">...</span>}
              {/* Page Numbers */}
              {Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
                .filter(page => page > 1 && page < totalPages)
                .map(page => (
                  <span
                    key={page}
                    className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </span>
                ))
              }
              {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
              {/* Last page */}
              {totalPages > 1 && (
                <span
                  className={`mx-1 px-2 py-1 border ${currentPage === totalPages ? 'border-dark fw-bold' : 'border-transparent'}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </span>
              )}
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
              >
                Next
              </button>
            </div>
          )}

          {showModal && selectedInvoice && (
            <PayModal
              show={showModal}
              handleClose={handleCloseModal}
              invoiceData={selectedInvoice}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AllDueHistory;